(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gd-v2-header"]) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.gd-nav-group[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.gd-nav-group[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-v2-inquiry"]) return;
  try {
    
document.querySelectorAll('[data-gd-source-url]').forEach(input=>{input.value=location.href.slice(0,1000);});
document.querySelectorAll('[data-gd-source-campaign]').forEach(input=>{const value=new URLSearchParams(location.search).get('source');if(value)input.value=value.slice(0,120);});
document.querySelectorAll('[data-gd-inquiry-product]').forEach(input=>{const value=new URLSearchParams(location.search).get('product');if(value){input.value=value.slice(0,250);const form=input.closest('form');const name=form.querySelector('[data-gd-product-name]');const context=form.querySelector('[data-gd-product-context]');if(name&&context){name.textContent=input.value;context.hidden=false;}}});
document.querySelectorAll('[data-gd-inquiry-configuration]').forEach(input=>{const value=new URLSearchParams(location.search).get('configuration');if(value){input.value=value.slice(0,500);const form=input.closest('form');const name=form.querySelector('[data-gd-configuration-name]');const context=form.querySelector('[data-gd-configuration-context]');if(name&&context){name.textContent=input.value;context.hidden=false;}}});
document.querySelectorAll('[data-gd-customer-type]').forEach(select=>{const value=new URLSearchParams(location.search).get('customer_type');if(value&&[...select.options].some(option=>option.value===value))select.value=value;});
document.querySelectorAll('[data-gd-project-stage]').forEach(input=>{const value=new URLSearchParams(location.search).get('project_stage');if(value&&[...input.options].some(option=>option.value===value))input.value=value;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-v2-product"]) return;
  try {
    
document.querySelectorAll('[data-gd-config-link]').forEach(link=>{link.addEventListener('click',()=>{const selections=[...document.querySelectorAll('[data-gd-option]')].filter(input=>input.value).map(input=>input.dataset.label+': '+input.value);const url=new URL(link.href,location.href);if(selections.length)url.searchParams.set('configuration',selections.join('; '));else url.searchParams.delete('configuration');link.href=url.href;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-v4-catalog"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.gd4-catalog').forEach(root=>{
  const cards=[...root.querySelectorAll('[data-gd-card]')];
  const tabs=[...root.querySelectorAll('[data-gd-category]')];
  const search=root.querySelector('[data-gd-search]');
  const voltage=root.querySelector('[data-gd-voltage]');const color=root.querySelector('[data-gd-color]');
  let category='all';
  const apply=()=>{
    const term=search.value.toLowerCase().trim();let count=0;
    cards.forEach(card=>{const show=(category==='all'||card.dataset.category===category)&&card.dataset.search.toLowerCase().includes(term)&&(!voltage.value||card.dataset.voltage.split(',').includes(voltage.value))&&(!color.value||card.dataset.color.split(' ')[0]===color.value);card.hidden=!show;if(show)count++;});
    tabs.forEach(tab=>tab.dataset.gdCategory===category?tab.setAttribute('aria-current','true'):tab.removeAttribute('aria-current'));
    const counter=root.querySelector('[data-gd-count]');counter.textContent=count+' '+counter.dataset.label;
    root.querySelector('[data-gd-empty]').hidden=count>0;
  };
  const fromUrl=()=>{const h=new URLSearchParams(location.search).get('category')||location.hash.slice(1);category=tabs.some(t=>t.dataset.gdCategory===h)?h:'all';apply();};
  tabs.forEach(tab=>tab.addEventListener('click',e=>{e.preventDefault();const u=new URL(location.href);u.searchParams.set('category',tab.dataset.gdCategory);u.hash='';history.replaceState(null,'',u.pathname+u.search);category=tab.dataset.gdCategory;apply();}));
  root.querySelector('[data-gd-reset]').addEventListener('click',()=>{search.value='';voltage.value='';color.value='';category='all';const u=new URL(location.href);u.searchParams.delete('category');history.replaceState(null,'',u.pathname);apply();search.focus();});
  voltage.addEventListener('change',apply);color.addEventListener('change',apply);search.addEventListener('input',apply);fromUrl();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
